import { useRouteAutoFlightController } from "../../hooks/useRouteAutoFlightController";
import { PropsWithChildren } from "react";
import { UploadPreprocessorProvider } from "components/modules/UploadPreprocessing/UploadPreprocessorContext";
import { SideNavProvider } from "./SideNavContext";
import { PdfTronProvider } from "./PdfTronContext";
import { SelectedViewerProvider } from "./SelectedViewerContext";
import UploadDialogProvider from "components/modules/UploadDialog/UploadDialogProvider";
import { RecentProjectsStorageProvider } from "./RecentProjectsStorageProvider";

export default function ProjectProviders(p: PropsWithChildren) {
  useRouteAutoFlightController();

  return (
    <UploadDialogProvider>
      <UploadPreprocessorProvider>
        <SideNavProvider>
          <SelectedViewerProvider>
            <RecentProjectsStorageProvider>
              <PdfTronProvider>{p.children}</PdfTronProvider>
            </RecentProjectsStorageProvider>
          </SelectedViewerProvider>
        </SideNavProvider>
      </UploadPreprocessorProvider>
    </UploadDialogProvider>
  );
}
